import { ApiRespBacklogMetricsByBuckets } from '@/pages/OperationsInsights/types/BacklogMetricsResponse';

/**
 * Transform Chart Series - for Backlog In, Out, totalOpen by Interval
 *
 * @param response
 */
export const tfCsBLInOutByInterval = (response: ApiRespBacklogMetricsByBuckets) => [
    {
        type: 'bar' as const,
        name: 'Created',
        yAxis: 'yaxis-left',
        stack: 'CreatedStack',
        data: response.metrics.map((item) => [ new Date(item.bucket).valueOf(), item.createdCount ?? 0 ])
    },
    {
        type: 'bar' as const,
        name: 'Completed Breached',
        yAxis: 'yaxis-left',
        color: 'red',
        stack: 'CompletedStack',
        data: response.metrics.map((item) => [ new Date(item.bucket).valueOf(), item.closedBreached ?? 0 ])
    },
    {
        type: 'bar' as const,
        name: 'Completed within SLA',
        yAxis: 'yaxis-left',
        color: 'green',
        stack: 'CompletedStack',
        data: response.metrics.map((item) => [ new Date(item.bucket).valueOf(), item.closedWithinSLA ?? 0 ])
    },
    {
        type: 'line' as const,
        name: 'Total Backlog',
        yAxis: 'yaxis-right',
        color: 'black',
        data: response.metrics.map((item) => [ new Date(item.bucket).valueOf(), item.openCount ?? 0 ])
    }
];